
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"2.695","height":"19.732","rx":"1.348","transform":"scale(-.99103 -1.0089) rotate(-45 -24.772 12.167)","fill":"#E7E7E7","stroke":"#3F3F3F"}}),_c('rect',{attrs:{"width":"2.695","height":"19.732","rx":"1.348","transform":"matrix(.70076 .7134 -.70076 .7134 14.11 0)","fill":"#E7E7E7","stroke":"#3F3F3F"}})])
          )
        }
      }
    